import { defaultLocale, Locale, locales } from '@/lib/i18n/dictionaries';
import { siteConfig } from '@/lib/i18n/en';
import { siteConfigCN } from '@/lib/i18n/zh-cn';
import { isBrowser } from '@/lib/window';

export function getLang(lang?: Locale | string) {
  const existingLocale = locales.find((locale) => locale === lang);

  return {
    lang: existingLocale || defaultLocale,
    usedFallbackLang: !existingLocale,
  };
}

export function getLangFromSlug(slug: string[]) {
  const lang = slug[0];

  return getLang(lang);
}

export function localesActions() {
  return {
    en: {
      text: 'English',
      link: siteConfig.url,
    },
    cn: {
      text: '中文 Chinese',
      link: siteConfigCN.url,
    },
  } as const;
}

export function modifyLinkIfSelected({
  link,
  text,
}: {
  link: string;
  text: string;
}) {
  const isCurrentLocale = isBrowser && window.location.href.startsWith(link);

  if (isCurrentLocale)
    return (
      <div className='text-primary-P99 group whitespace-nowrap'>{text}</div>
    );

  return null;
}
